<app-menu [menuItems]="menu"></app-menu>
